import React, { useEffect } from 'react'

import { Box, Center, Image, Text } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'
import { useLocation, useRouteError } from 'react-router-dom'

import { reportError } from './redux/features/errorSlice'
const FALLBACK = '[empty]'

const ErrorBoundary = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  let error = useRouteError()

  useEffect(() => {
    if (!error) return

    const errorPayload = {
      error: {
        name: error.name || FALLBACK,
        message: error.message || FALLBACK,
        stack: error.stack || FALLBACK,
      },
      context: {
        path: location.pathname,
        user_agent: navigator.userAgent,
        viewport: { width: window.innerWidth, height: window.innerHeight },
        environment: process.env.NODE_ENV ?? '',
        error_source: 'Component',
      },
    }

    dispatch(reportError(errorPayload))
  }, [error])

  return (
    <Center h='100vh'>
      <Box boxSize='600px'>
        <Image src='assets/error.jpg' />
        <Text align='center'>
          Something went wrong! Council Connect administrators have been
          notified of the error and will handle this as soon as possible.
        </Text>
      </Box>
    </Center>
  )
}

export default ErrorBoundary
